import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component( {
  template: `
    <div mat-dialog-title>{{ title }}</div>
    <mat-divider class="modal-header-divider"></mat-divider>
    <div mat-dialog-content>
      {{ message }}
    </div>
    <mat-divider class="modal-footer-divider"></mat-divider>
    <div mat-dialog-actions>
      <button mat-button color="warn" (click)="onClickCancel()">{{ cancelButtonLabel }}</button>
      <button mat-raised-button class="confirm-button" color="primary" (click)="onClickConfirm()">
        {{ confirmButtonLabel }}
      </button>
    </div>
  `,
  // styleUrls: [ './confirmation-dialog.component.scss' ],
} )
export class CloseSettingsConfirmationComponent {

  title: string = 'You have unsaved changes to your settings';
  message: string = 'What would you like to do?';
  confirmButtonLabel: string = 'SAVE AND CLOSE';
  cancelButtonLabel: string = 'CLOSE WITHOUT SAVING';

  constructor(
    private readonly dialogRef: MatDialogRef<CloseSettingsConfirmationComponent, boolean>,
    @Inject( MAT_DIALOG_DATA ) public data: any ) {
    if ( data?.title ) {
      this.title = data.title;
    }
    if ( data?.message ) {
      this.message = data.message;
    }
    if ( data?.confirmButtonLabel ) {
      this.confirmButtonLabel = data.confirmButtonLabel;
    }
    if ( data?.cancelButtonLabel ) {
      this.cancelButtonLabel = data.cancelButtonLabel;
    }
  }

  onClickCancel() {
    this.dialogRef.close( false );
  }

  onClickConfirm() {
    this.dialogRef.close( true );
  }

}
